import { useTranslation } from "react-i18next";

function Hero({ config }) {
  const { t } = useTranslation();
  return (
    <div className="bg-modern-bgLight relative overflow-hidden">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-0">
        {config.show_hero_catch && (
          <div className="mt-10 pt-3 md:mt-4 md:flex justify-center text-center">
            <span className="inline-flex items-center gap-x-2 bg-modern-bgWhite border border-modern-accent text-xs text-modern-textDark sm:text-sm lg:text-base p-1 ps-3 pe-3 rounded-full">
              {t('わたしの')} {t('記号・番号')}、{t('保険者番号')} {t('はどこで確認できるの？')}
            </span>
          </div>
        )}

        <div className="mt-0 pt-1 md:pt-0 lg:mt-8 mb-3 max-w-4xl text-center mx-auto">
          <h1 className="block font-bold mt-2 text-modern-textDark text-3xl md:text-5xl lg:text-6xl">
            <span className="text-modern-primary">
              {t(config.title_head)}
            </span>
            {t(config.title_tail)}
          </h1>
        </div>

        {config.show_hero_lead && (
          <div className="mb-4 md:mb-0 rounded-lg mt-8 p-4 max-w-3xl text-center mx-auto">
            <p className="leading-8 tracking-wide text-modern-textMedium">
              {t('加入している健康保険の')}
              <strong>
                <u>{t('記号・番号')}</u>
              </strong>
              {t('や')}
              <strong>
                <u>{t('保険者番号')}</u>
              </strong>
              {t('は、以下の方法で確認できます。')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Hero;
